export const DEFAULT_INSPECTED_USER = {
  turf: {},
  role: {
    permissions: [],
  },
  assigned_packets: [],
}
